import script from "./ShareBetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBetModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareBetModal.vue?vue&type=style&index=0&id=fa4bc21e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa4bc21e"]])

export default __exports__